import axios from 'axios';
import { get } from 'lodash';
import ConfigurationValuesService, { IConfigurationValuesService } from './ConfigurationValuesService';

export interface IHttpService {
    post(url: string, body?: any, additionalHeaders?: any): Promise<any>;
    get(url: string, params?: any, additionalHeaders?: any): any;
}

export default class HttpService implements IHttpService {
    readonly configurationValuesService: IConfigurationValuesService;

    constructor() {
        this.configurationValuesService = ConfigurationValuesService.getInstance();
    }

    async post(url: string, data: any = {}, additionalHeaders?: any): Promise<any> {
        const guestTokenObject = await this.getGuestToken();
        const guestToken = get(guestTokenObject, 'data.token');
        const Authorization = `Bearer ${guestToken}`;

        return axios({
            method: 'POST',
            url,
            data,
            headers: {
                Authorization,
                ...additionalHeaders
            }
        });
    }

    async get(url: string, params: any = {}, additionalHeaders?: any) {
        return await axios.get(url, params);
    }

    async getGuestToken() {
        const url = `${this.configurationValuesService.apiUrl}/sessions/guest`;
        return await this.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/services/HttpService.ts